import MAYA from '../../../maya_api'

const SAVE_USER = 'SAVE_USER';
const GET_USER = 'GET_USER';

// ------------------------------------
// Actions
// ------------------------------------
function saveUser(value) {
  return {
    type: SAVE_USER,
    payload: value
  }
}

function getUser() {
  return async (dispatch, getStore) => {

    const result = await MAYA.getDeviceUser();
    if(!result){
      return console.log('User info error', result);
    }

    dispatch({
      type: GET_USER,
      payload: {
        id: result.id,
        role: result.role,
        username: result.username,
        partner_id: result.partner_id
      }
    })
  }
}

export {
  saveUser,
  getUser
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SAVE_USER]: (state, action) => action.payload,
  [GET_USER]: (state, action) => action.payload
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  id: -1,
  role: '',
  username: '',
  partner_id: -1
};

export default function userReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}




// WEBPACK FOOTER //
// ./src/routes/Login/modules/user.js